<template>
  <footer class="app-bottom" role="contentinfo" aria-label="Barra inferior de navegación">
    <div class="app-bottom__inner">
      <div class="app-bottom__side app-bottom__side--left">
        <ButtonPrime
          v-if="$route.name !== 'home' && !isDisablingBottom"
          type="button"
          class="app-bottom__btn"
          icon="pi pi-arrow-left"
          text
          rounded
          aria-label="Volver atrás"
          @click.prevent="goBack"
        />
        <ButtonPrime
          v-else-if="$route.name !== 'home' && isDisablingBottom"
          type="button"
          class="app-bottom__btn"
          icon="pi pi-arrow-left"
          text
          rounded
          disabled
          aria-label="Espera para volver atrás"
        />
        <span v-else class="app-bottom__spacer" aria-hidden="true" />
      </div>

      <div class="app-bottom__center">
        <div class="app-bottom__mark">
          <span class="app-bottom__copy" :title="'Año ' + year">© {{ year }}</span>
          <span class="app-bottom__dot" aria-hidden="true" />
          <span class="app-bottom__name">Estudyoo</span>
        </div>
        <p class="app-bottom__line">Panel de administración · Uso interno</p>
      </div>

      <div class="app-bottom__side app-bottom__side--right">
        <ButtonPrime
          v-if="$route.name !== 'home'"
          type="button"
          class="app-bottom__btn"
          icon="pi pi-home"
          text
          rounded
          aria-label="Ir al inicio"
          @click.prevent="goTo('home')"
        />
        <ButtonPrime
          v-if="$route.name !== 'home'"
          type="button"
          class="app-bottom__btn"
          icon="pi pi-arrow-up"
          text
          rounded
          aria-label="Volver arriba"
          @click.prevent="scrollUp"
        />
        <span v-else class="app-bottom__spacer" aria-hidden="true" />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'BottomBar',
  data() {
    return {
      disablingButton: false,
    };
  },
  computed: {
    isDisablingBottom() {
      return this.disablingButton;
    },
    year() {
      return new Date().getFullYear();
    },
  },
  methods: {
    goBack() {
      const b = this;
      b.disablingButton = true;
      window.setTimeout(() => {
        b.disablingButton = false;
      }, 2000);
      this.$router.go(-1);
    },
    goTo(route) {
      this.$router.push({ name: route });
    },
    scrollUp() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
.app-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9000;
  border-top: 1px solid var(--admin-border, rgba(15, 23, 42, 0.09));
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 -1px 0 rgba(255, 255, 255, 0.7) inset, 0 -8px 32px rgba(15, 23, 42, 0.06);
  font-family: var(--admin-font, inherit);
}

.app-bottom__inner {
  display: grid;
  grid-template-columns: minmax(2.5rem, 1fr) minmax(0, auto) minmax(2.5rem, 1fr);
  align-items: center;
  gap: 0.5rem 0.75rem;
  min-height: 3.5rem;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0.65rem 1rem 0.7rem;
  box-sizing: border-box;
}

.app-bottom__side {
  display: flex;
  align-items: center;
  min-height: 2.25rem;
}

.app-bottom__side--left {
  justify-content: flex-start;
}

.app-bottom__side--right {
  justify-content: flex-end;
  gap: 0.2rem;
}

/* Columna central: bloque fijo al centro real del viewport */
.app-bottom__center {
  text-align: center;
  max-width: min(22rem, 100%);
  margin: 0 auto;
  justify-self: center;
  grid-column: 2;
}

.app-bottom__mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.35rem 0.5rem;
  line-height: 1.2;
}

.app-bottom__copy {
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--admin-text-muted, #64748b);
}

.app-bottom__dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: var(--admin-text-muted, #94a3b8);
  flex-shrink: 0;
  opacity: 0.7;
}

.app-bottom__name {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--admin-text, #0f172a);
}

.app-bottom__line {
  margin: 0.28rem 0 0;
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: var(--admin-text-muted, #94a3b8);
  line-height: 1.35;
}

.app-bottom__btn :deep(.p-button) {
  color: var(--admin-text-muted, #64748b) !important;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  transition: color 0.15s ease, background 0.15s ease;
}

.app-bottom__btn :deep(.p-button:enabled:hover) {
  color: var(--primary-color) !important;
  background: rgba(37, 99, 235, 0.08) !important;
}

.app-bottom__spacer {
  display: inline-block;
  width: 2.25rem;
  height: 2.25rem;
  flex-shrink: 0;
}

@media (max-width: 480px) {
  .app-bottom__inner {
    padding-left: 0.65rem;
    padding-right: 0.65rem;
  }

  .app-bottom__line {
    display: none;
  }

  .app-bottom__copy {
    font-size: 0.68rem;
  }

  .app-bottom__name {
    font-size: 0.78rem;
  }
}
</style>
